import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Card } from 'antd';
import FormValueSelector from '../../../containers/FormValueSelector';
import ImageLoader from '../../atoms/ImageLoader';

const ProductSelect = ({ product }) => {
  return (
    <label htmlFor={product.product_id}>
      <FormValueSelector fieldName={product.product_id}>
        {checked => {
          const styles = checked
            ? { minWidth: 100, border: '2px solid #52c41a' }
            : { minWidth: 100, borderWidth: 2 };
          return (
            <Card
              style={styles}
              hoverable
              bordered
              cover={
                <ImageLoader style={{ width: 'auto', margin: '0 auto' }} src={product.url_image} />
              }
            >
              <Card.Meta style={{ textAlign: 'center' }} description={product.name} />
              <Field
                style={{ display: 'none' }}
                name={product.product_id}
                id={product.product_id}
                component="input"
                type="checkbox"
              />
            </Card>
          );
        }}
      </FormValueSelector>
    </label>
  );
};

ProductSelect.propTypes = {
  product: PropTypes.shape({
    product_id: PropTypes.number,
    name: PropTypes.string,
    url_image: PropTypes.string,
  }).isRequired,
};

export default ProductSelect;
